import MuiTooltip from '@mui/material/Tooltip'

const Tooltip = ({ sx, ...props }) => (
  <MuiTooltip
    {...props}
    componentsProps={{
      tooltip: {
        sx: {
          backgroundColor: theme => theme.palette.secondary_140.main,
          color: theme => `${theme.palette.secondary_80.main} !important`,
          ...sx,
        },
      },
    }}
  />
)

export default Tooltip
